import React, { memo, useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Drawer, Layout } from "antd";
import { Scrollbars } from "react-custom-scrollbars-2";
import SubjectDetailsSidebar from "./admin-layout/SubjectDetailsSidebar";
import AdminSideBar from "./admin-layout/AdminSidebar";
import CustomSideBar from "./admin-layout/CustomSidebar";
import HeaderBar from "./admin-layout/Header";
import BreadCrumb from "../components/common/BreadCrumb";
import { getClientOrganization } from "@src/redux/index";
import { useSelector } from "react-redux";
import { startCase } from "lodash";
import ReadingFilterSideBar from "./admin-layout/ReadingFilterSidebar";
import { useTranslation } from "react-i18next";
import { Sidebar } from "react-pro-sidebar";
import { SIDEBAR_IMAGE } from "@src/helpers/imagesConstants";
import { IoClose } from "react-icons/io5";

const { Content } = Layout;
interface BreadCrumbProps {
  title: string;
  path: string;
}
const AdminLayoutTemplate = memo(() => {
  const location = useLocation();
  const { id } = useParams();
  const { t } = useTranslation();
  const [sideBarModal, setSideBarModal] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [title, setTitle] = useState("");
  const [breadCrumbItems, setBreadCrumbItems] = useState<
    BreadCrumbProps[]
  >([]);
  const { result: getClientOrganizationResult } = useSelector(
    getClientOrganization
  );

  const toggle = () => {
    setSideBarModal(!sideBarModal);
  };
  const handleCloseSidebar = () => {
    setSideBarModal(false);
  };

  useEffect(() => {
    let parts = document.title.split("|");
    let place = parts[0].trim();
    setTitle(place);
  }, []);

  const handleScroll = (value: { scrollTop: number }) => {
    const scroll = value.scrollTop;
    setShowTitle(scroll > 40);
  };

  const renderSidebar = () => {
    if (location.pathname.includes("/details/")) {
      return <SubjectDetailsSidebar />;
    } else if (location.pathname.includes("home")) {
      return <ReadingFilterSideBar />;
    }
    // else
    // if (location.pathname === "/settings/home") {
    //   return <AdminSideBar />;
    // }
    else
      return (
        <CustomSideBar
          sideBarModal={sideBarModal}
          onCloseSideBar={handleCloseSidebar}
        />
      );
  };

  useEffect(() => {
    if (location?.pathname?.split("/")?.[2]?.includes("client")) {
      setBreadCrumbItems([
        { path: "/settings/clients", title: "Clients" },
        {
          path: "",
          title: id
            ? getClientOrganizationResult?.name || ""
            : "Create Client",
        },
      ]);
    }
  }, [location, getClientOrganizationResult]);

  return (
    <div style={{ padding: "3px" }}>
      <Layout className="layout">
        {!location.pathname.includes("/on-board-analysis") && (
          <Sidebar
            collapsed={sideBarModal}
            className="side-bar"
            image={SIDEBAR_IMAGE}
          >
            <Scrollbars>{renderSidebar()}</Scrollbars>
          </Sidebar>
        )}
        <div className="header_and_content_container">
          <HeaderBar
            title={title}
            showTitle={showTitle}
            toggle={toggle}
            setTitle={setTitle}
          />
          {breadCrumbItems.length > 0 &&
          startCase(location?.pathname?.split("/")?.[2]) ? (
            <div className="custom-layout-header">
              <span className="custom-layout-title">
                {breadCrumbItems.length > 0 ? (
                  <BreadCrumb items={breadCrumbItems} />
                ) : (
                  startCase(location?.pathname?.split("/")?.[2])
                )}
              </span>
            </div>
          ) : (
            // <div style={{ marginBottom: "10px" }} />
            ""
          )}
          <Scrollbars
            id="scrollableElement"
            onScrollFrame={handleScroll}
            style={{ overflow: "hidden" }}
          >
            <Content className="main_content">
              <Outlet />
            </Content>
          </Scrollbars>
        </div>
      </Layout>
      <Drawer
        open={sideBarModal}
        onClose={toggle}
        title={
          !location.pathname.includes("home") ? t("Settings") : t("filter")
        }
        closeIcon={<IoClose color="white" size={30} />}
        placement="left"
      >
        <Scrollbars>{renderSidebar()}</Scrollbars>
      </Drawer>
    </div>
  );
});

export default AdminLayoutTemplate;
